import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { businessTabTitle, hasPageTitle } from "../../hooks/useDocumentTitle";

const TAB_TITLES = { en: "Stylon", ar: "Stylon", he: "Stylon" };

/**
 * The document's direction, language and — for a page that names no tab of its
 * own — the tab title, kept in step with the chosen language: the business the
 * page was served for, or the platform's name on the platform's own pages.
 * Lifted out of App.js so a test can mount it without the whole app.
 */
export default function RtlSync() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = (i18n.language || "en").split("-")[0];
    const dir = ["ar", "he"].includes(lang) ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.documentElement.setAttribute("lang", lang);
    // A page that named its tab keeps it. A page that has not (yet) is the
    // business it was served for, and "Stylon" only on Stylon's own pages.
    if (TAB_TITLES[lang] && !hasPageTitle()) document.title = businessTabTitle() || TAB_TITLES[lang];
  }, [i18n.language]);
  return null;
}
